(function () {
  const observer = new MutationObserver((mutations, obs) => {
    const checkoutBtn = document.querySelector('[name="checkout"]');
    if (checkoutBtn) {
      console.log("[ReturnCostPrompt] Checkout button detected via MutationObserver");

      checkoutBtn.addEventListener("click", function (e) {
        console.log("[ReturnCostPrompt] Checkout button clicked");

        const confirmed = window.confirm("Bitte beachten Sie, dass Sie die Rücksendekosten für alle Artikel selbst tragen müssen.");
        if (!confirmed) {
          console.log("[ReturnCostPrompt] User cancelled checkout");
          e.preventDefault();
        } else {
          console.log("[ReturnCostPrompt] User confirmed checkout");
        }
      });

      obs.disconnect(); // Stop observing once bound
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log("[ReturnCostPrompt] MutationObserver initialized");
})();
